var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RESET, UPDATE_ALTERNATEFLOWCLICKED, UPDATE_ANALYTICS, UPDATE_CONFIG, UPDATE_ERROR_CONTAINER, UPDATE_HASANALYTICS, UPDATE_ISAUTHENTICATED, UPDATE_ISAUTHENTICATEDUI, UPDATE_ISCANCEL, UPDATE_ISPHONENUMBER, UPDATE_IS_LOADING, UPDATE_LANGUAGECODE, UPDATE_PARAMS, UPDATE_PAYLOAD, UPDATE_SFFDL, UPDATE_TRUSTSCOREERRORCONTAINER, UPDATE_TRUSTSCORERETRYCOUNT, UPDATE_TRUST_SCORE_ACTION } from '../constants/action-types';
export var initialState = {
    isAuthenticated: false,
    isCancelAuthenticatorEnabled: false,
    phoneNumber: ' ',
    languageCode: ' ',
    errorContainer: '',
    isAuthenticatedUI: false,
    payload: '',
    hasAnalytics: false,
    analytics: {},
    SFFDL: {},
    config: {},
    params: {},
    showAlternateFlow: false,
    trustscoreRetryCount: 0,
    isTrustScoreErrorContainer: false,
    isLoading: true,
    trustScoreAction: null
};
function rootReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_TRUST_SCORE_ACTION:
            return __assign(__assign({}, state), { trustScoreAction: action.payload });
        case UPDATE_ISAUTHENTICATED:
            return __assign(__assign({}, state), { isAuthenticated: action.payload });
        case UPDATE_ISAUTHENTICATEDUI:
            return __assign(__assign({}, state), { isAuthenticatedUI: action.payload });
        case UPDATE_ISPHONENUMBER:
            return __assign(__assign({}, state), { phoneNumber: action.payload });
        case UPDATE_PAYLOAD:
            return __assign(__assign({}, state), { payload: action.payload });
        case RESET:
            return initialState;
        case UPDATE_LANGUAGECODE:
            return __assign(__assign({}, state), { languageCode: action.payload });
        case UPDATE_ERROR_CONTAINER:
            return __assign(__assign({}, state), { errorContainer: action.payload });
        case UPDATE_ISCANCEL:
            return __assign(__assign({}, state), { isCancelAuthenticatorEnabled: action.payload });
        case UPDATE_HASANALYTICS:
            return __assign(__assign({}, state), { hasAnalytics: action.payload });
        case UPDATE_ANALYTICS:
            return __assign(__assign({}, state), { analytics: action.payload });
        case UPDATE_SFFDL:
            return __assign(__assign({}, state), { SFFDL: action.payload });
        case UPDATE_CONFIG:
            return __assign(__assign({}, state), { config: action.payload });
        case UPDATE_PARAMS:
            return __assign(__assign({}, state), { params: action.payload });
        case UPDATE_ALTERNATEFLOWCLICKED:
            return __assign(__assign({}, state), { showAlternateFlow: action.payload });
        case UPDATE_TRUSTSCORERETRYCOUNT:
            return __assign(__assign({}, state), { trustscoreRetryCount: action.payload });
        case UPDATE_TRUSTSCOREERRORCONTAINER:
            return __assign(__assign({}, state), { isTrustScoreErrorContainer: action.payload });
        case UPDATE_IS_LOADING:
            return __assign(__assign({}, state), { isLoading: action.payload });
        default:
            return state;
    }
}
export default rootReducer;
